import apiClient from './index'

export default {
  // Categorías
  getCategorias() {
    return apiClient.get('/indicadores/categorias')
  },
  
  getCategoria(id) {
    return apiClient.get(`/indicadores/categorias/${id}`)
  },
  
  createCategoria(data) {
    return apiClient.post('/indicadores/categorias', data)
  },
  
  updateCategoria(id, data) {
    return apiClient.put(`/indicadores/categorias/${id}`, data)
  },
  
  deleteCategoria(id) {
    return apiClient.delete(`/indicadores/categorias/${id}`)
  },
  
  // Indicadores
  getIndicadores(params = {}) {
    return apiClient.get('/indicadores', { params })
  },
  
  getIndicador(id) {
    return apiClient.get(`/indicadores/${id}`)
  },
  
  createIndicador(data) {
    return apiClient.post('/indicadores', data)
  },
  
  updateIndicador(id, data) {
    return apiClient.put(`/indicadores/${id}`, data)
  },
  
  deleteIndicador(id) {
    return apiClient.delete(`/indicadores/${id}`)
  }
}